import { StreamActions } from "@hotwired/turbo"
import { Modal } from "bootstrap"

StreamActions.hide_modal = function () {
  this.targetElements.forEach(modalElement => {
    Modal.getInstance(modalElement)?.hide()
  })
}

StreamActions.scroll_to_top = () => {
  window.scrollTo(0, 0)
}
